const YOUTUBE_HOSTS = [
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'youtu.be',
  'www.youtu.be',
];

const extractIframeSrc = (value) => {
  const match = String(value || '').match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
  return match ? match[1].replace(/&amp;/g, '&') : value;
};

const getYoutubeUrl = (value) => {
  if (!value || typeof value !== 'string') {
    return null;
  }

  try {
    return new URL(extractIframeSrc(value).trim());
  } catch {
    return null;
  }
};

const getVideoId = (url) => {
  const host = url.hostname.replace(/^www\./, '');

  if (host === 'youtu.be') {
    return url.pathname.split('/').filter(Boolean)[0];
  }

  if (!host.endsWith('youtube.com')) {
    return '';
  }

  if (url.pathname === '/watch') {
    return url.searchParams.get('v');
  }

  const [, type, id] = url.pathname.split('/');

  if (['embed', 'shorts', 'live'].includes(type)) {
    return id;
  }

  return '';
};

const getStartSeconds = (value) => {
  if (!value) {
    return '';
  }

  if (/^\d+$/.test(value)) {
    return value;
  }

  const hours = value.match(/(\d+)h/);
  const minutes = value.match(/(\d+)m/);
  const seconds = value.match(/(\d+)s/);
  const total =
    Number(hours?.[1] || 0) * 3600 +
    Number(minutes?.[1] || 0) * 60 +
    Number(seconds?.[1] || 0);

  return total ? String(total) : '';
};

export const isYoutubeUrl = (value) => {
  const url = getYoutubeUrl(value);

  if (!url || !YOUTUBE_HOSTS.includes(url.hostname)) {
    return false;
  }

  return Boolean(getVideoId(url) || url.searchParams.get('list'));
};

export const normalizeYoutubeEmbedUrl = (value) => {
  const url = getYoutubeUrl(value);

  if (!url || !YOUTUBE_HOSTS.includes(url.hostname)) {
    return value;
  }

  const videoId = getVideoId(url);
  const playlistId = url.searchParams.get('list');

  if (videoId) {
    const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
    const start = getStartSeconds(
      url.searchParams.get('start') || url.searchParams.get('t')
    );

    if (start) {
      embedUrl.searchParams.set('start', start);
    }

    return embedUrl.toString();
  }

  if (playlistId) {
    const embedUrl = new URL('https://www.youtube.com/embed/videoseries');
    embedUrl.searchParams.set('list', playlistId);
    return embedUrl.toString();
  }

  return value;
};
